// Seed Data Constants — All bilingual (English + Sindhi)
export const DISTRICTS = [
  { id: "DIST_KHI", name: "Karachi", sd: "ڪراچي" },
  { id: "DIST_HYD", name: "Hyderabad", sd: "حيدرآباد" },
  { id: "DIST_SKR", name: "Sukkur", sd: "سکر" },
  { id: "DIST_LRK", name: "Larkana", sd: "لاڙڪاڻو" },
  { id: "DIST_NWB", name: "Nawabshah", sd: "نوابشاھ" },
  { id: "DIST_MPK", name: "Mirpurkhas", sd: "مير پور خاص" },
];

export const LIT_FIELDS = [
  { id: "LF_POETRY", name: "Poetry (Shairi)", sd: "شاعري" },
  { id: "LF_FICTION", name: "Fiction (Afsana)", sd: "افسانو" },
  { id: "LF_NOVEL", name: "Novel", sd: "ناول" },
  { id: "LF_TANQEED", name: "Criticism (Tanqeed)", sd: "تنقيد" },
  { id: "LF_TAREEKH", name: "History (Tareekh)", sd: "تاريخ" },
  { id: "LF_BIO", name: "Biography", sd: "سوانح عمري" },
  { id: "LF_CHILD", name: "Children Literature", sd: "ٻارن جو ادب" },
  { id: "LF_LATIF", name: "Latifiyat", sd: "لطيفيات" },
];

export const EDUCATION_OPTIONS = [
  { value: "matric", en: "Matric", sd: "ميٽرڪ" },
  { value: "intermediate", en: "Intermediate", sd: "انٽرميڊيٽ" },
  { value: "graduation", en: "Graduation (BA/BSc)", sd: "گريجوئيشن" },
  { value: "masters", en: "Masters (MA/MSc)", sd: "ماسٽرز" },
  { value: "mphil", en: "M.Phil", sd: "ايم فل" },
  { value: "phd", en: "PhD", sd: "پي ايڇ ڊي" },
  { value: "other", en: "Other", sd: "ٻيو" },
];

export const BRANCHES = [
  { id: "BR_CLIFTON", name: "Clifton Branch", sd: "ڪلفٽن شاخ", dist: "DIST_KHI", city: "Clifton", citySD: "ڪلفٽن", desc: "Serving the literary community in Clifton, Karachi.", descSD: "ڪراچي جي ڪلفٽن ۾ ادبي برادري جي خدمت." },
  { id: "BR_QASIM", name: "Qasimabad Branch", sd: "قاسم آباد شاخ", dist: "DIST_HYD", city: "Qasimabad", citySD: "قاسم آباد", desc: "Active literary branch in Hyderabad.", descSD: "حيدرآباد ۾ فعال ادبي شاخ." },
  { id: "BR_SUKKUR", name: "Sukkur City Branch", sd: "سکر سٽي شاخ", dist: "DIST_SKR", city: "Sukkur", citySD: "سکر", desc: "One of the most active branches in upper Sindh.", descSD: "مٿي سنڌ ۾ سڀ کان فعال شاخن مان هڪ." },
  { id: "BR_LRKNA", name: "Larkana Branch", sd: "لاڙڪاڻو شاخ", dist: "DIST_LRK", city: "Larkana", citySD: "لاڙڪاڻو", desc: "Promoting literature in the heart of Sindh.", descSD: "سنڌ جي دل ۾ ادب جي واڌاري." },
];

export const CENTRAL_BODY = [
  { id: "U_ADMIN", name: "Admin Sindhi", sd: "ايڊمن سنڌي", email: "admin@sas.pk", role: "main_admin" },
  { id: "U_CB_SG", name: "Ghulam Mustafa", sd: "غلام مصطفيٰ", email: "sg@sas.pk", role: "center_body_secretary_general" },
  { id: "U_CB_JS", name: "Nasreen Bhutto", sd: "نسرين ڀٽو", email: "js@sas.pk", role: "center_body_joint_secretary" },
  { id: "U_CB_TR", name: "Qadir Bux", sd: "قادر بخش", email: "tr@sas.pk", role: "center_body_treasurer" },
  { id: "U_CB_AU", name: "Hyder Ali", sd: "حيدر علي", email: "au@sas.pk", role: "center_body_auditor" },
  { id: "U_CB_WJ", name: "Marvi Shoro", sd: "مارئي شورو", email: "wjs@sas.pk", role: "center_body_woman_joint_secretary" },
];

export const DIST_COORDINATORS = [
  { id: "U_DC_KHI", name: "Akhtar Hussain", sd: "اختر حسين", email: "dc.khi@sas.pk", dist: "DIST_KHI" },
  { id: "U_DC_HYD", name: "Noor Ahmed", sd: "نور احمد", email: "dc.hyd@sas.pk", dist: "DIST_HYD" },
  { id: "U_DC_SKR", name: "Mumtaz Ali", sd: "ممتاز علي", email: "dc.skr@sas.pk", dist: "DIST_SKR" },
  { id: "U_DC_LRK", name: "Waheed Ahmed", sd: "وحيد احمد", email: "dc.lrk@sas.pk", dist: "DIST_LRK" },
  { id: "U_DC_NWB", name: "Sarfraz Shah", sd: "سرفراز شاھ", email: "dc.nwb@sas.pk", dist: "DIST_NWB" },
  { id: "U_DC_MPK", name: "Iqbal Mirpuri", sd: "اقبال مير پوري", email: "dc.mpk@sas.pk", dist: "DIST_MPK" },
];

// 5 officers per branch: SG, JS, TR, AU, Counselor
const ROLES = ["branch_secretary_general","branch_joint_secretary","branch_treasurer","branch_auditor","branch_counselor"];
const BR_OFFICERS_DATA = {
  BR_CLIFTON: [
    { name: "Ahmed Ali", sd: "احمد علي", lit: "Ahmed Adabi" },
    { name: "Fatima Khan", sd: "فاطمه خان", lit: "" },
    { name: "Bilal Soomro", sd: "بلال سومرو", lit: "" },
    { name: "Saima Baloch", sd: "صائمه بلوچ", lit: "" },
    { name: "Waqar Shah", sd: "وقار شاھ", lit: "" },
  ],
  BR_QASIM: [
    { name: "Zafar Iqbal", sd: "ظفر اقبال", lit: "Zafar Sindhi" },
    { name: "Sana Javed", sd: "ثنا جاويد", lit: "" },
    { name: "Rashid Brohi", sd: "راشد بروهي", lit: "" },
    { name: "Nazia Parveen", sd: "نازيه پروين", lit: "" },
    { name: "Kamran Leghari", sd: "ڪامران ليغاري", lit: "" },
  ],
  BR_SUKKUR: [
    { name: "Nasir Shah", sd: "ناصر شاھ", lit: "Nasir Bhittai" },
    { name: "Rubina Kalhoro", sd: "روبينه ڪلهوڙو", lit: "" },
    { name: "Sajjad Memon", sd: "سجاد ميمڻ", lit: "" },
    { name: "Farah Naz", sd: "فرح ناز", lit: "" },
    { name: "Asad Shar", sd: "اسد شر", lit: "" },
  ],
  BR_LRKNA: [
    { name: "Mushtaq Chandio", sd: "مشتاق چانڊيو", lit: "Mushtaq Larkano" },
    { name: "Shahnaz Panhwar", sd: "شاھناز پنهور", lit: "" },
    { name: "Irfan Khoso", sd: "عرفان کوسو", lit: "" },
    { name: "Abida Solangi", sd: "عابده سولنگي", lit: "" },
    { name: "Pervez Jamali", sd: "پرويز جمالي", lit: "" },
  ],
};

// 3 regular members per branch
const BR_MEMBERS_DATA = {
  BR_CLIFTON: [
    { name: "Aisha Begum", sd: "عائشه بيگم" },
    { name: "Tariq Malik", sd: "طارق ملڪ" },
    { name: "Zubaida Shah", sd: "زبيده شاھ" },
  ],
  BR_QASIM: [
    { name: "Imran Khan", sd: "عمران خان" },
    { name: "Samina Rajput", sd: "ثمينه راجپوت" },
    { name: "Habib Shaikh", sd: "حبيب شيخ" },
  ],
  BR_SUKKUR: [
    { name: "Khadija Abro", sd: "خديجه ابڙو" },
    { name: "Saleem Rind", sd: "سليم رند" },
    { name: "Amna Bhatti", sd: "آمنه ڀٽي" },
  ],
  BR_LRKNA: [
    { name: "Dilshad Qureshi", sd: "دلشاد قريشي" },
    { name: "Noman Shaikh", sd: "نعمان شيخ" },
    { name: "Bushra Talpur", sd: "بشريٰ ٽالپر" },
  ],
};

// Generate branch officers with IDs
export const BRANCH_OFFICERS = [];
export const BRANCH_MEMBERS = [];
let memberCount = 1;

Object.keys(BR_OFFICERS_DATA).forEach(brId => {
  const dist = BRANCHES.find(b => b.id === brId).dist;
  BR_OFFICERS_DATA[brId].forEach((p, i) => {
    const mId = `M_${String(memberCount).padStart(3,'0')}`;
    const uId = `U_${String(memberCount).padStart(3,'0')}`;
    BRANCH_OFFICERS.push({ mId, uId, ...p, role: ROLES[i], brId, dist, phone: `03${String(100+memberCount).slice(0,2)}-${String(1000000+memberCount*111)}` });
    memberCount++;
  });
  BR_MEMBERS_DATA[brId].forEach(p => {
    const mId = `M_${String(memberCount).padStart(3,'0')}`;
    const uId = `U_${String(memberCount).padStart(3,'0')}`;
    BRANCH_MEMBERS.push({ mId, uId, ...p, role: "member", brId, dist, phone: `03${String(100+memberCount).slice(0,2)}-${String(1000000+memberCount*111)}` });
    memberCount++;
  });
});

export const SAMPLE_BOOKS = [
  { title_en: "The Essence of Sindhi Poetry", title_sd: "سنڌي شاعري جو جوهر", author_en: "Ahmed Ali", author_sd: "احمد علي", publisher_en: "Sindhi Adabi Board", publisher_sd: "سنڌي ادبي بورڊ", genre: "Shairi (Poetry)", publication_year: 2023, author_id: "M_001" },
  { title_en: "Tales from the Indus", title_sd: "سنڌو جا قصا", author_en: "Zafar Iqbal", author_sd: "ظفر اقبال", publisher_en: "Mehran Publishers", publisher_sd: "مهران پبلشرز", genre: "Afsana", publication_year: 2022, author_id: "M_006" },
  { title_en: "Modern Sindhi Literature", title_sd: "جديد سنڌي ادب", author_en: "Nasir Shah", author_sd: "ناصر شاھ", publisher_en: "SAS Publications", publisher_sd: "سنڌي ادبي سنگت اشاعت", genre: "Tanqeed", publication_year: 2024, author_id: "M_011" },
];

export const SAMPLE_EVENTS = [
  { title: "Annual Literary Festival 2026", titleSindhi: "سالياني ادبي ميلو 2026", description: "Join us for the annual literary festival celebrating Sindhi literature.", descriptionSindhi: "سنڌي ادب جو جشن ملهائيندڙ سالياني ادبي ميلي ۾ شامل ٿيو.", type: "event", date: "2026-06-15", venue: "SAS Hall, Karachi", isGlobal: true },
  { title: "Poetry Workshop for Youth", titleSindhi: "نوجوانن لاءِ شاعري ورڪشاپ", description: "A hands-on workshop for aspiring young Sindhi poets.", descriptionSindhi: "نوجوان سنڌي شاعرن لاءِ عملي ورڪشاپ.", type: "event", date: "2026-05-20", venue: "Clifton Branch Office", isGlobal: false, branchId: "BR_CLIFTON" },
  { title: "New Book Release", titleSindhi: "نئين ڪتاب جي رليز", description: "Release of 'Modern Sindhi Literature' by Nasir Shah.", descriptionSindhi: "ناصر شاھ جي 'جديد سنڌي ادب' جي رليز.", type: "announcement", date: "2026-05-10", isGlobal: true },
];

export const SAMPLE_ACTIVITY_LOGS = [
  { branchId: "BR_CLIFTON", title: "Monthly Literary Meeting", titleSindhi: "مهيني جي ادبي گڏجاڻي", description: "Discussed upcoming literary events and member contributions.", descriptionSindhi: "ايندڙ ادبي تقريبن ۽ ميمبرن جي حصي تي بحث ڪيو ويو.", timestamp: { seconds: Math.floor(Date.now() / 1000) - 86400 * 2 } },
  { branchId: "BR_CLIFTON", title: "Poetry Recitation Session", titleSindhi: "شاعري پڙهڻ جي نشست", description: "Young poets shared their latest work with seniors.", descriptionSindhi: "نوجوان شاعرن پنهنجو تازو ڪم وڏن سان شيئر ڪيو.", timestamp: { seconds: Math.floor(Date.now() / 1000) - 86400 * 5 } },
  { branchId: "BR_QASIM", title: "Branch Executive Meeting", titleSindhi: "شاخ ايگزيڪيوٽو گڏجاڻي", description: "Planning for the next district-level seminar.", descriptionSindhi: "ايندڙ ضلعي سطح جي سيمينار جي رٿابندي.", timestamp: { seconds: Math.floor(Date.now() / 1000) - 86400 * 3 } },
];
